var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 27.0573L14.3767 8.94237C14.4119 8.7202 14.5875 8.54507 14.8127 8.50741C15.038 8.46975 15.2624 8.5781 15.3702 8.77638L18.3452 14.237L19.531 12.0151C19.6229 11.8433 19.8039 11.7357 20.0012 11.7357C20.1985 11.7357 20.3795 11.8433 20.4714 12.0151L28.4999 27.0573H11.5V27.0573Z",
    fill: "#FFA000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4383 20.0008L18.3438 14.2344L11.5 27.0573L21.4383 20.0008Z",
    fill: "#F57C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 27.0574L26.2966 13.6397C26.2634 13.447 26.1236 13.2888 25.9344 13.2291C25.7451 13.1694 25.538 13.2191 25.3975 13.3572L11.5 27.0572L19.1898 31.301C19.6727 31.5663 20.2608 31.5663 20.7437 31.301L28.5 27.0572V27.0574Z",
    fill: "#FFCA28"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.46867bb10523f834badfa84c08ff86dd.svg";
export { ForwardRef as ReactComponent };